/**
 * Copyright © 2026 Delicious AI, LLC
 */

import { gql } from '@apollo/client'

export const PARSED_FACING_DATA_FRAGMENT = gql`
  fragment ParsedFacingData on ParsedFacingData {
    upc
    columnIndex
    quantity
    vFacings
  }
`
